<template>
    <el-row :gutter="30" class="mw-100">
        <el-col :lg="24" :xs="24">
           
            <el-card class="box-card">
                <el-table :data="footerParagraphs" style="width: 100%">
                    
                    
                    
                   <el-table-column label="title En">
                        <template #default="scope">
                           {{$getLocaleData(scope.row.translates,'en_us').title}}
                        </template>
                    </el-table-column>

                   
                    <el-table-column label="description En" >
                        <template #default="scope">
                           {{$getLocaleData(scope.row.translates,'en_us').description}}
                        </template>
                    </el-table-column>

                    <el-table-column label="title Ar" align="right" >
                        <template #default="scope">
                           <div class="">
                               {{$getLocaleData(scope.row.translates,'ar_sa').title}}
                           </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="description Ar"  >
                        <template #default="scope">
                           <div class="rtl text-right">
                               {{$getLocaleData(scope.row.translates,'ar_sa').description}}
                           </div>
                        </template>
                    </el-table-column>
                  
                    <el-table-column label="Operations" width="100" align="right">
                        <template #default="scope">
                            <el-tooltip
                                class="box-item"
                                effect="dark"
                                content="edit paragraph"
                                placement="top"
                            >
                                <font-awesome-icon :icon="['fas', 'edit']" style="width:20px" @click="handleEditFooterParagraph(scope.row)" class="cursor-pointer" />
                            </el-tooltip>
                             
                                
                        </template>
                    </el-table-column>
                </el-table>
               
            </el-card>
        </el-col>
    </el-row>
</template>
<script>
export default {
    computed:{
        cachedFooterParagraphs(){
            return JSON.parse(localStorage.getItem('adminStore'))?.website?.settings?.footer?.footerParagraphs?.list || []
        },
    },
    data(){
        return{
            footerParagraphs:[],
            footerParagraphStatus:[],
           
        }
    },
    async mounted(){
        if (!this.cachedFooterParagraphs?.length){
            this.getFooterParagraph();
        }else{
            this.footerParagraphs = this.cachedFooterParagraphs;
          
        }
        
       
    },
    
    methods:{
       
        async getFooterParagraph(){
            const response = await this.$store.dispatch('getFooterParagraph');

            this.footerParagraphs = [response];
             
        },
        
      
        async handleEditFooterParagraph(footerParagraph){
            await this.$store.dispatch('storeCurrentFooterParagraphToView',footerParagraph)
            this.$router.push({
                name:'manage-footer-paragraph',
                params:{
                    id:footerParagraph.id
                }
            })
        },
      
    
       
        
    }
}
</script>
<style lang="scss">
    .text-right.rtl {
        .cell {
            text-align: right;
            direction: rtl;
        }
    }
</style>